module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-upload', {
    staticClass: "import-deal",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.host + _vm.source.url,
      "headers": _vm.headers,
      "data": _vm.getData(),
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "file-list": _vm.fileList
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3da4a5da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/deal/importDeal.vue
// module id = 1833
// module chunks = 2